import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'

export const RoomLabelsAndCashbackWrapper = styled.div<{lineBreak?: boolean}>`
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s200};
  ${({lineBreak}) =>
    lineBreak &&
    `
    flex-direction: column;
    align-items: flex-start;
    gap: ${cssTheme.layout.spacing.s000};
  `}
`
